export function voiceflowChatbot() {
	if (!window.voiceflowEnabled || !window.chatbotProjektId) return

	;(function (d, t) {
		var v = d.createElement(t),
			s = d.getElementsByTagName(t)[0]
		v.onload = function () {
			window.voiceflow.chat
				.load({
					verify: { projectID: window.chatbotProjektId },
					url: 'https://general-runtime.voiceflow.com',
					versionID: 'production',
					voice: {
						url: 'https://runtime-api.voiceflow.com',
					},
					launch: {
						event: {
							type: 'launch',
							payload: {
								url: window.location.href,
							},
						},
					},
				})
				.then(() => {
					var isHomePage = window.location.href === '/'
					var isPropertyPage = window.location.href.startsWith('/immobilien/')

					// Proaktive Nachricht je nach Seitenart
					setTimeout(function () {
						window.voiceflow.chat.proactive.clear()
						if (isPropertyPage) {
							window.voiceflow.chat.proactive.push({
								type: 'text',
								payload: { message: 'Diese Immobilie könnte Ihr neues Zuhause sein! Ich beantworte alle Fragen und sende Ihnen alle Details – starten Sie jetzt!🏡😊' },
							})
						} else {
							window.voiceflow.chat.proactive.push({
								type: 'text',
								payload: { message: 'Ich bin Ihr intelligenter Assistent Chatti!🤖 Immobilien kaufen, verkaufen oder bewerten? Ich helfe Ihnen sofort – starten Sie jetzt!🏡😊' },
							})
						}
					}, 1000)

					// Chat-Öffnungszähler aus localStorage abrufen
					var openCount = localStorage.getItem('chatOpenCount') || 0
					openCount = parseInt(openCount, 10)

					if (openCount < 1) {
						// Automatisches Öffnen deaktiviert
						localStorage.setItem('chatOpenCount', openCount + 1)
					} else if (openCount < 2) {
						// Automatisches Öffnen deaktiviert
						localStorage.setItem('chatOpenCount', openCount + 1)
					}

					// chatOpenCount nach 5 Minuten zurücksetzen
					setInterval(function () {
						localStorage.removeItem('chatOpenCount')
					}, 300000) // 300000 Millisekunden = 5 Minuten

					// Adjust the bottom position of the launcher on mobile
					function adjustLauncher() {
						if (window.innerWidth <= 768) {
							document
								.querySelector('#voiceflow-chat')
								?.shadowRoot?.querySelectorAll('.vfrc-launcher__container')
								.forEach((el) => el.style.setProperty('bottom', '90px', 'important'))
						} else {
							document
								.querySelector('#voiceflow-chat')
								?.shadowRoot?.querySelectorAll('.vfrc-launcher__container')
								.forEach((el) => el.style.setProperty('bottom', '25px', 'important'))
						}
					}
					adjustLauncher()
					window.addEventListener('resize', adjustLauncher)

					// Call adjustLauncher every second for the first 30 seconds
					let adjustInterval = setInterval(adjustLauncher, 1000)
					setTimeout(() => {
						clearInterval(adjustInterval)
					}, 30000)
				})
		}
		v.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs'
		v.type = 'text/javascript'
		s.parentNode.insertBefore(v, s)
	})(document, 'script')
}
